<template>
  <div class="service-card-container">
    <div class="service-card-icon">
      <span :class="icon"></span>
    </div>
    <p class="service-card-title">{{ title }}</p>
    <p class="service-card-description">{{ description }}</p>
  </div>
</template>
<script>
/**
 * Componente, do tipo 'Card', para descrever um serviço oferecido.
 */
export default {
  name: 'ServiceCard',
  props: {
    /**
     * Título/Nome do serviço.
     */
    title: {
      type: String
    },
    /**
     * Classe Webfont disponibilizada em Material Design Icons.
     */
    icon: {
      type: String
    },
    /**
     * Descrição para o serviço.
     */
    description: {
      type: String
    }
  }
}
</script>
<style scoped>
.service-card-container {
  /* Variables */
  --cinza-transp: #afafaf30;
  --cinza: #afafaf;
  --azul-claro: #101624b7;
  --azul-escuro: #070D1B;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid 1px var(--cinza-transp);
  border-radius: 0.25rem;
  background-color: var(--azul-claro);
  padding: 3rem;
  gap: 1rem;
  width: 100%;
  height: inherit;
}
.service-card-icon {
  border: solid 1px var(--cinza-transp);
  border-radius: 50%;
  color: var(--cinza);
  font-size: 3rem;
  padding: 0.25rem 1rem;
  background-color:var(--azul-escuro);
  transition: all 0.5s ease-in;
}
.service-card-title {
  font-size: 1.25rem;
  text-align: center;
  transition: all 0.5s ease-in;
}
.service-card-description {
  color: var(--cinza);
  font-size: 0.875rem;
  font-weight: 300;
  text-align: center;
}
.service-card-container:hover .service-card-icon {
  color: gold;
  border: solid 1px gold;
}
.service-card-container:hover .service-card-title {
  color: gold;
}
</style>